<template>
  <div class="notfound">
    <div class="div1">您访问的页面正在建设中!</div>
    <div class="div2">您访问的页面未建设完成，请点击页底的按钮返回</div>
    <div class="div3">404</div>
    <div class="div4">!访问出错!</div>
    <div class="div5">
      <button class="div5-button" @click="$router.back()">返回</button>
      <button class="div5-button" @click="$router.back()">上一页</button>
    </div>
  </div>
</template>

<script>
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/12 19:37
 * @Description 路由未找到界面
 */
export default {
  name: "notfound",
};
</script>

<style scoped>
.notfound {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.div1 {
  font-size: 1.9rem;
}

.div2 {
  font-size: 0.85rem;
}

.div3 {
  font-size: 60px;
}

.div4 {
  font-size: 1.9rem;
}

.div5 {
  margin-top: 50px;
  display: flex;
  column-gap: 50px;
}

.div5-button {
  font-size: 1rem;
  padding: 2px 12px;
}
</style>
